import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AdminAuditLogsStateData } from '@/types/audit-log'

export type AdminAuditLogsState = {
  data: AdminAuditLogsStateData
  error: string | null
}

export const adminAuditLogsInitialState: AdminAuditLogsState = {
  data: {
    logs: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: 'adminAuditLogs',
  initialState: adminAuditLogsInitialState,
  reducers: {
    setAdminAuditLogsAction(state, { payload }: PayloadAction<AdminAuditLogsStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminAuditLogsErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminAuditLogsAction, setAdminAuditLogsErrorAction } = slice.actions
export default slice.reducer
